import React, { useState } from "react";
import { Row, Card, Divider } from 'antd'; 
import { compose, graphql, ApolloConsumer } from 'react-apollo';
import { addClientM, updateClientM } from '../../../graphql/mutation/client';
import { getClient } from '../../../graphql/query/client';
import AntSpin from "../../common/AntSpin";
import SimpleInput from "../../common/SimpleInput";
import Document from "../../common/form/Document";
import Phones from "../../common/form/Phones";
import Email from "../../common/form/Email";
import SelectBranch from "../../common/selects/Branch";
import { handleInput } from "./handleInput";
import { validForm } from "../../../functions/validForm";
import { openNotificationWithIcon } from "../../common/Notification";
import SideButton from "../../common/SideButton";

function ClientForm({props, addClient, updateClient}){
    let [ client, setClient ] = useState({
        _id: "",
        name: undefined,
        document: undefined,
        branch: undefined,
        email: "",
        phone: "",
        celphone: "",
    });
    let [ loading, setLoading ] = useState(false);

    function update(){
        let body = {
            client,
            updateClient
        };

        props.UPDATE_CLIENT(body);
        openNotificationWithIcon('success', "Sucesso", "Cliente atualizado com sucesso", "", 7);
        setClient(client = {...client,
            _id: "",
            name: undefined,
            document: undefined,
            branch: undefined,
            email: "",
            phone: "",
            celphone: "",
        })
    }

    function add(){
        let body = {
            client,
            addClient
        };
        
        props.ADD_CLIENT(body);
        openNotificationWithIcon('success', "Sucesso", "Cliente adicionado com sucesso", "", 7);

        setClient(client = {...client,
            _id: "",
            name: undefined,
            document: undefined,
            branch: undefined,
            email: "",
            phone: "",
            celphone: "",
        })
    }

    function handleOk(){
        if(!validForm(client)){
            openNotificationWithIcon('warning', "Aviso", "Há informações incompletas no formulario.", "", 5);
            return 
        }
        
        if(client._id === "") add()
        else update()   
    }

    async function getClientDB(connection){
        if(localStorage.getItem('@Ossel:UpdateID')){
            setLoading(loading = true);

            const { data } = await connection.query({
                query: getClient,
                variables: { _id: localStorage.getItem('@Ossel:UpdateID') }
            }); 
            
            setClient(client = {...client,
                _id: data.client._id,
                name: data.client.name,
                document: data.client.document,
                branch: data.client.branch_info[0]._id,
                email: data.client.email,
                phone: data.client.phone,
                celphone: data.client.celphone
            });
          
            localStorage.removeItem('@Ossel:UpdateID');
            setLoading(loading = false);
        }

        return null
    }
    
    function renderBody(connection){
        getClientDB(connection);

        if(!loading) return(
            <Row>
                <Card
                    title="Cadastro"
                    style={{ width: "95%", marginTop: 25, marginLeft: "auto", marginRight: "auto" }}
                >

                    <SimpleInput
                        data={client} 
                        setData={setClient} 
                        handleInput={handleInput} 
                        label={"Nome completo"}
                        inputName={"name"}
                        placeholder={"Ex: João Barros"}
                        required={true}
                    />

                    <Document 
                        data={client} 
                        setData={setClient} 
                        handleInput={handleInput}
                        required={true}
                        label={"CPF"}
                    />

                    <SelectBranch
                        data1={client} 
                        setData={setClient} 
                        handleInput={handleInput} 
                        profile={props.user}
                    />

                    <Email 
                        data={client} 
                        setData={setClient} 
                        handleInput={handleInput}
                        props={props}
                    />

                    <Divider>Contato</Divider>

                    <Phones 
                        data={client} 
                        setData={setClient} 
                        handleInput={handleInput}
                    />    

                    <SideButton
                        clickAction={handleOk}
                    />
                </Card>
            </Row>
        )
        else return <AntSpin marginTop={"20%"}/>
    }

    return (
        <ApolloConsumer>
            {client => renderBody(client)}
        </ApolloConsumer>
    );
}

export default compose(
    graphql( addClientM, { name: "addClient" } ),
    graphql( updateClientM, { name: "updateClient" } ),
)(ClientForm); 


// WEBPACK FOOTER //
// ./src/components/general/clientFormWrapper/ClientForm.jsx